"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArchMo;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Icon = require('@tencent/ixd-icons-react/dist').Icon;

function ArchMo(props) {
  var handleClickPic = props.handleClickPic,
      handleisShow = props.handleisShow;

  var _a = (0, _utils.fomateFileData)(handleClickPic),
      newHandleClickPic = _a.url,
      _b = _a.alt,
      handleClickPicAlt = _b === void 0 ? '' : _b;

  var handleClose = function handleClose() {
    handleisShow(false);
  };

  var flag = 0;
  (0, _react.useEffect)(function () {
    flag = 1;
    document.addEventListener('touchmove', function (event) {
      // 监听滚动事件
      if (flag == 1) {
        // 判断是遮罩显示时执行，禁止滚屏
        event.preventDefault(); // 最关键的一句，禁止浏览器默认行为
      }
    }, {
      passive: false
    });
    return function () {
      flag = 0;
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'architectureMobile'
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: "close",
    className: 'icon',
    onClick: handleClose
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: 'mobile-pic',
    src: newHandleClickPic ? newHandleClickPic : 'https://test-staticintl.cloudcachetci.com/cms/backend-cms/VSLU252_%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_16508696385265.png',
    alt: handleClickPicAlt
  }));
}